export const CSS_LABEL = 'css';

export const getPathAfterCss = (path) => {
  let isAfterCss = false;
  return path.map(o => {
    if (o === CSS_LABEL) {
      isAfterCss = true; return undefined;
    }
    return isAfterCss ? o : undefined
  }).filter(o => o !== undefined);
}

export const getPathBeforeCss = (path) => {
  let isAfterCss = false;
  return path.map(o => {
    if (o === CSS_LABEL) {
      isAfterCss = true; 
      return undefined;
    }
    return isAfterCss ? undefined : o
  }).filter(o => o !== undefined);
}

export const computeCSSProps = ({ pathForValue, value, initialValue, initialCssPlus, initialCssMinus }) => {
  const path = getPathAfterCss(pathForValue);

  path.forEach(item => {
    if (initialValue) {
      initialValue = initialValue[item];
    }

    if (initialCssPlus) {
      initialCssPlus = initialCssPlus[item];
    }

    if (initialCssMinus) {
      initialCssMinus = initialCssMinus[item];
    }
  });

  const classes = typeof value === 'string' ? value.split(' ') : [];
  const initialClasses = typeof initialValue === 'string' ? initialValue.split(' ') : [];

  const cssPlusClasses = typeof initialCssPlus === 'string' ? initialCssPlus.split(' ') : [];
  const cssMinusClasses = typeof initialCssMinus === 'string' ? initialCssMinus.split(' ') : [];

  classes.forEach((className) => {
    // Handle case where there is new css classes compared to initial value
    if (!initialClasses.includes(className)) {
      const minusIndex = cssMinusClasses.indexOf(className);
      if (minusIndex !== -1) {
        cssMinusClasses.splice(minusIndex, 1);
      }

      const plusIndex = cssPlusClasses.indexOf(className);
      if (plusIndex === -1) {
        cssPlusClasses.push(className);
      }
    }
  });

  // Handle case where there css classes were removed compared to initial value
  initialClasses.forEach((className) => {
    if (!classes.includes(className)) {
      const plusIndex = cssPlusClasses.indexOf(className);
      if (plusIndex !== -1) {
        cssPlusClasses.splice(plusIndex, 1);
      }

      const minusIndex = cssMinusClasses.indexOf(className);
      if (minusIndex === -1) {
        cssMinusClasses.push(className);
      }
    }
  });

  return {
    cssPlus: cssPlusClasses.join(' '),
    cssMinus: cssMinusClasses.join(' '),
  };
};

const getCSSData = ({ cssKey, css, cssPlus, cssMinus }) => {
  const nestedCss = css[cssKey.name];
  const nestedCssPlus = cssPlus[cssKey.name];
  const nestedCssMinus = cssMinus[cssKey.name];

  let keys = cssKey.keys || [];

  if (cssKey.type === 'Object') {
    cssKey.keys = keys.map((nestedKey) => getCSSData({
      cssKey: nestedKey,
      css: nestedCss || {},
      cssPlus: nestedCssPlus || {},
      cssMinus: nestedCssMinus || {},
    })
    );
    const initialValue = {};
    cssKey.keys.forEach(key => {
      initialValue[key.name] = key.initialValue;
    })

    return {
      ...cssKey,
      initialValue
    }
  }
  else {
    // Build up the initialValue for css in classes array
    const classes = [];

    // First add the css defined under css prop
    if (typeof nestedCss === 'string') {
      nestedCss.split(' ').forEach((className) => {
        classes.push(className);
      });
    }
    // If no css defined then add the default value
    else if (typeof cssKey.defaultValue === 'string') {
      cssKey.defaultValue.split(' ').forEach((className) => {
        classes.push(className);
      });
    }

    // Add on top the cssPlus classes
    if (typeof nestedCssPlus === 'string') {
      nestedCssPlus.split(' ').filter((className) => !classes.includes(className)).forEach((className) => {
        classes.push(className);
      });
    }

    // Subtract from all the cssMinus
    if (typeof nestedCssMinus === 'string') {
      nestedCssMinus.split(' ').forEach((className) => {
        const index = classes.indexOf(className);
        if (index !== -1) {
          classes.splice(index, 1);
        }
      });
    }

    const initialValue = classes.join(' ');

    return {
      ...cssKey,
      initialValue
    }
  }
};

export const getCSS = ({ param, css = {}, cssPlus = {}, cssMinus = {} }) => {
  const propData = param;
  propData.keys = param.keys.map((cssKey) => getCSSData({
    cssKey,
    css,
    cssPlus,
    cssMinus,
  })
  );

  return propData;
};

const css = {
  computeCSSProps,
  getCSS,
  getPathAfterCss,
  getPathBeforeCss
};

export default css;